/*
 * The Edit Dubai: collection page (sections/collection-template.liquid). Loaded by that section only, with defer.
 *
 * The products, the filter list and the sort list are built in the browser by Boost (assets/bc-sf-filter.js), which
 * fires "te:collection:updated" with the number of products after every load, filter and sort. This file adds what
 * sits around them:
 * - the product count in the toolbar and on the filter drawer's "View results" button;
 * - the filter drawer's bottom bar (Clear all, View results);
 * - no filter column and no Filter button on a collection that has nothing to filter by;
 * - "Read more" on a long description (phones, where the styles cut it to three lines).
 */
(function () {
  'use strict';

  var section = document.getElementById('shopify-section-collection-template');

  if (!section) {
    return;
  }

  var root = section.querySelector('.te-coll') || section;
  var drawer = document.getElementById('collection-filter-drawer');
  var tree = document.getElementById('bc-sf-filter-tree');
  var countElements = section.querySelectorAll('[data-te-coll-count]');
  var applyButton = section.querySelector('[data-te-coll-apply]');
  var clearButton = section.querySelector('[data-te-coll-clear]');
  var moreButton = section.querySelector('[data-te-coll-more]');
  var text = document.getElementById('te-coll-text');
  var counted = false;

  function productsText(count) {
    return count === 1 ? '1 product' : count + ' products';
  }

  // Boost keeps the chosen filters in the address as pf_... parameters
  function hasActiveFilters() {
    return /[?&]pf_/.test(window.location.search);
  }

  function showCount(count) {
    for (var i = 0; i < countElements.length; i++) {
      countElements[i].textContent = productsText(count);
    }

    if (applyButton) {
      applyButton.textContent = count > 0 ? 'View ' + productsText(count) : 'View results';
    }
  }

  // A filter that lists a single value (Brand on a brand's own page) filters nothing, so it is hidden, in the sidebar
  // and in the drawer. When that leaves no filter at all, the column and the Filter button go and the grid takes the
  // full width (te-collection.css).
  function hideSingleValueFilters(list) {
    var blocks = list ? list.querySelectorAll('.bc-sf-filter-option-block') : [];

    for (var i = 0; i < blocks.length; i++) {
      var values = blocks[i].querySelectorAll('.bc-sf-filter-block-content li');
      var single = values.length === 1 && !blocks[i].querySelector('.selected');

      blocks[i].classList.toggle('te-coll-filter--single', single);
    }
  }

  function updateFilters() {
    if (!tree || tree.querySelector('.bc-sf-filter-option-skeleton')) {
      return; // Boost has not built the list yet
    }

    hideSingleValueFilters(tree);
    hideSingleValueFilters(document.getElementById('bc-sf-filter-tree2'));

    var filters = tree.querySelectorAll('.bc-sf-filter-option-block:not(.bc-sf-filter-option-hidden):not(.te-coll-filter--single)').length;

    // The section sets the class itself for a single-brand collection (its best guess before Boost answers)
    root.classList.toggle('te-coll--no-filters', filters === 0 && !hasActiveFilters());

    if (clearButton) {
      clearButton.disabled = !hasActiveFilters();
    }
  }

  document.addEventListener('te:collection:updated', function (event) {
    var total = event.detail ? parseInt(event.detail.total, 10) : NaN;

    if (!isNaN(total)) {
      counted = true;
      showCount(total);
    }

    updateFilters();
  });

  // Boost did not answer (blocked or offline): show the number Shopify counted for the whole collection
  window.setTimeout(function () {
    var fallback = countElements.length ? parseInt(countElements[0].getAttribute('data-fallback'), 10) : NaN;

    if (!counted && !isNaN(fallback)) {
      showCount(fallback);
    }
  }, 6000);

  if (tree && 'MutationObserver' in window) {
    var scheduled = false;

    new MutationObserver(function () {
      if (scheduled) {
        return;
      }

      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        updateFilters();
      });
    }).observe(tree, { childList: true, subtree: true });
  }

  window.addEventListener('popstate', updateFilters);
  updateFilters();

  // Filter drawer bar. Closing goes through the drawer's own X, so custom.js also hides the overlay and frees the page.
  if (applyButton && drawer) {
    applyButton.addEventListener('click', function () {
      var closeButton = drawer.querySelector('.Drawer__Close');

      if (closeButton) {
        closeButton.click();
      }
    });
  }

  if (clearButton) {
    clearButton.addEventListener('click', function (event) {
      if (typeof window.clearAllFilterOptions === 'function') {
        window.clearAllFilterOptions(event); // Boost's own "Clear All"
      } else {
        window.location.href = window.location.pathname;
      }
    });
  }

  // Read more
  function updateMore() {
    if (!moreButton || !text) {
      return;
    }

    var open = text.classList.contains('is-open');

    moreButton.hidden = !open && text.scrollHeight <= text.clientHeight + 1;
  }

  if (moreButton && text) {
    moreButton.addEventListener('click', function () {
      var open = text.classList.toggle('is-open');

      moreButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      moreButton.textContent = open ? 'Read less' : 'Read more';
    });

    window.addEventListener('resize', updateMore);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateMore);
    }

    updateMore();
  }
})();
